import type { GetStaticPaths, GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

import type { NewsRelease } from '@/types/newsRelease'

export { NewsArticlePage as default } from '@/components/pages/News/Release/NewsId'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = new NewtClient()
  const newsRelease = await client.fetchNewsRelease()

  const paths = newsRelease.map((item: any) => ({
    params: { newsId: item._id },
  }))

  return {
    paths,
    fallback: false,
  }
}

type Props = {
  news: NewsRelease
}

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const client = new NewtClient()
  const news = await client.fetchNews(`${params?.newsId}`)

  return {
    props: {
      news,
    },
  }
}
